//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Breadcrumbs } from '~/plugins/breadcrumbs'
import { CACHE_SETTINGS } from '~/utils/cache'
import { vLog } from '~/utils/vLog'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import FaqItems from '~/components/Flotillas/FaqItems'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'

export default {
  name: 'CleanOcean',
  components:{
    FaqItems,
  },
  mixins: [pageMeta],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'dynamic',
          type: 'clean_ocean_overview',
          path: ctx.route.path
        }
      })
      const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
      const lang = ctx.store.getters['lang/locale']
      const ietf = ietfLocale || 'en-gb'
      const page = await ctx.$cacheFetch({
        key: `pCleanOcean-FetchCleanOcean?locale=${ietf}`, expire: CACHE_SETTINGS.baseTime
      }, async () => {
        const { data } = await ctx.$aProxy.get('/getClearOcean', {
          params: { lang, ietf }
        })
        return data
      })

      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('safe-the-planet'),
        url: ctx.route.fullPath
      }])
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      if (Object.keys(page).length === 0) {
        ctx.error({ statusCode: 404, message: 'Page not found' })
        // ctx.redirect({ name: 'error.page', params: { slug: 404, lang: ctx.store.getters['lang/locale'] } })
        return
      }

      return {
        page
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      faq: {
        active: []
      }
    }
  },
  methods: {
    setActiveFAQ (number) {
      if (this.faq.active.includes(number)) {
        this.faq.active = this.faq.active.filter(v => v !== number)
        return
      }
      this.faq.active.push(number)
    }
  },
}
